import { motion } from 'motion/react';
import TileBackground from '../Host/Setup/TileBackground';
import { elementsTransition } from '@/utils/gamePacks';
import clsx from 'clsx';
import { GamePackIcon, GamePackPalette } from '@/API';
import { Link } from 'react-router-dom';

interface GamePackTileProps {
  id: string;
  hover: string;
  handleHover: (id: string) => void;
  icon: GamePackIcon;
  palette: GamePackPalette;
  name: string;
  description: string;
  promptsCount: number;
  isNew: boolean;
  categories?: string[];
}

export function GamePackTile({
  id,
  hover,
  handleHover,
  icon,
  palette,
  name,
  description,
  promptsCount,
  isNew,
  categories = []
}: GamePackTileProps) {
  const formattedCategories = categories
    .map((category) => category?.trim())
    .filter((category): category is string => !!category && category.length > 0);

  return (
    <motion.div
      layout
      onHoverStart={() => handleHover(id)}
      onHoverEnd={() => handleHover('')}
      className={clsx([
        'elevated h-264 p-8 border-neutral-200 border-1 bg-white  flex flex-col relative overflow-hidden group shrink-0 cursor-grab',
        hover === id ? 'w-280 rounded-2xs' : 'w-168 rounded-xs'
      ])}
      transition={elementsTransition}
    >
      {palette && icon && (
        <TileBackground
          gamepackPalette={palette}
          gamepackIcon={icon}
          hover={hover === id}
          isNewGamePack={isNew}
        />
      )}
      <motion.div
        layout
        className={clsx([
          'pt-6 pb-10 h-64 shrink-0 flex items-center z-10 flex-col overflow-hidden absolute left-0  select-none',
          hover === id
            ? 'h-full p-0 w-full items-start justify-end top-0 z-10 px-16'
            : 'top-192 px-8'
        ])}
        transition={elementsTransition}
      >
        <motion.p
          className="text-body-strong mb-4 w-full min-h-48 group-hover:min-h-1 flex items-center group-hover:text-h3 select-none px-8 group-hover:px-0"
          layout
          transition={elementsTransition}
        >
          {name}
        </motion.p>
        <p className="text-body opacity-0 group-hover:opacity-100 select-none">{description}</p>
        <Link
          to={`/dashboard/host?gamepack=${id}`}
          className={clsx(['btn btn-neutral w-full my-16 select-none'])}
        >
          View Prompts
        </Link>
        <div className="w-full pt-4 pb-4 select-none">
          <p className="text-body-sm-strong">
            {promptsCount} {promptsCount === 1 ? 'Prompt' : 'Prompts'}
          </p>
          {formattedCategories.length > 0 && (
            <p className="text-body-xs mt-2 text-neutral-500">{formattedCategories.join(' • ')}</p>
          )}
        </div>
      </motion.div>
    </motion.div>
  );
}
